import styled from 'styled-components'

import { fontWeight, color } from 'src/styles'
import { fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const Wrap = styled.div<{ bgStart: string; bgEnd: string }>`
  background-image: linear-gradient(238deg, #fffdee 100%, #fef7e2);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Title = styled.h2`
  font-size: ${fontSize.LARGE_XXXL};
  font-weight: ${fontWeight.EXTRA};
  margin: 3.2rem 0 0.8rem;
  color: ${color.GREYISH_BROWN};
`

export const Paragraph = styled.p`
  max-width: 28.5rem;
  color: ${color.WARM_GREY};
  text-align: center;
  margin: 0;
`

export const LoadingWrap = styled.div`
  position: absolute;
  bottom: 4rem;

  ${media.desktop} {
    margin-top: 20rem;
    bottom: unset;
    position: relative;
  }
`

export const Button = styled.button`
  position: absolute;
  top: 1.6rem;
  left: 2.4rem;
  padding: 0;

  ${media.desktop} {
    top: 2.4rem;
    right: 3.2rem;
    left: unset;
  }
`
